import React from 'react';
import './Features.scss';
import { Link } from 'react-router-dom';

const features = [
  {
    title: 'Omni-Channel Support',
    summary: 'Connect with customers wherever they are—seamlessly.',
    description: (
      <>
        Skil.AI empowers your business to engage customers across chat, email, voice, and social media—all from a single platform. <br />
        <ul>
          <li>Unified inbox for all channels</li>
          <li>Consistent experience, every time</li>
          <li>Boosts response speed and customer satisfaction</li>
        </ul>
      </>
    ),
    icon: 'globe',
  },
  {
    title: 'Business Customization',
    summary: 'Tailor every interaction to your unique workflows.',
    description: (
      <>
        Our AI adapts to your business rules, processes, and branding—no generic bots here. <br />
        <ul>
          <li>Customizable conversation flows</li>
          <li>Integrates with your existing tools</li>
          <li>Delivers a branded, on-message experience</li>
        </ul>
      </>
    ),
    icon: 'settings',
  },
  {
    title: 'Voice Recognition',
    summary: 'Understand and respond to natural speech, instantly.',
    description: (
      <>
        Advanced voice recognition lets your customers interact hands-free, making support and sales frictionless. <br />
        <ul>
          <li>Accurate, real-time voice-to-text</li>
          <li>Supports multiple accents and languages</li>
          <li>Perfect for phone, web, and mobile</li>
        </ul>
      </>
    ),
    icon: 'mic',
  },
  {
    title: 'Multi-Language Capabilities',
    summary: 'Break language barriers and expand your reach.',
    description: (
      <>
        Skil.AI speaks your customers' language—literally. <br />
        <ul>
          <li>Automatic translation in real time</li>
          <li>Supports 30+ global languages</li>
          <li>Delivers a local experience, everywhere</li>
        </ul>
      </>
    ),
    icon: 'language',
  },
  {
    title: 'Effortless Scalability',
    summary: 'Grow without limits—no extra overhead.',
    description: (
      <>
        Whether you serve 100 or 100,000 users, Skil.AI scales with you—instantly and reliably. <br />
        <ul>
          <li>Cloud-native, enterprise-ready</li>
          <li>No downtime, no bottlenecks</li>
          <li>Pay only for what you use</li>
        </ul>
      </>
    ),
    icon: 'expand',
  },
  {
    title: 'Adaptive Learning AI',
    summary: 'Gets smarter with every interaction.',
    description: (
      <>
        Our AI continuously learns from your data and customer conversations, improving accuracy and outcomes over time. <br />
        <ul>
          <li>Self-optimizing responses</li>
          <li>Insights for ongoing improvement</li>
          <li>Reduces manual intervention</li>
        </ul>
      </>
    ),
    icon: 'brain',
  },
  {
    title: 'Zero-Code Integration',
    summary: 'Deploy in minutes, not months—no IT headaches.',
    description: (
      <>
        Connect Skil.AI to your favorite tools and platforms with simple, code-free integrations. <br />
        <ul>
          <li>Plug-and-play connectors</li>
          <li>Works with CRM, ERP, HRIS, and more</li>
          <li>Empowers business users, not just developers</li>
        </ul>
      </>
    ),
    icon: 'plug',
  },
  {
    title: 'Instant Demo / See It in Action',
    summary: 'Experience the power of Skil.AI—risk free.',
    description: (
      <>
        See how Skil.AI can transform your business with a live, personalized demo. <br />
        <ul>
          <li>Interactive walkthroughs</li>
          <li>Real use cases for your industry</li>
          <li>Expert guidance, every step</li>
        </ul>
      </>
    ),
    icon: 'play',
  },
];

const Features = () => (
    <div className="features">
        <div className="features-page">
            <header className="features-header">
                <h1>AI-Powered Virtual Assistants, Built for Business Growth</h1>
                <p className="features-subheading">
                    Skil.AI delivers advanced automation, seamless integration, and real results—so you can focus on what matters most: growing your business.
                </p>
            </header>

            <section className="features-list">
                {features.map((feature, idx) => (
                    <div className="feature-item" key={feature.title}>
                        <div className={`feature-icon feature-icon--${feature.icon}`}></div>
                        <div className="feature-content">
                            <h2>{feature.title}</h2>
                            <h3>{feature.summary}</h3>
                            <div className="feature-description">{feature.description}</div>
                        </div>
                    </div>
                ))}
            </section>

            <section className="features-cta">
                <h2>Ready to see Skil.AI in action?</h2>
                <p>Request a personalized demo and discover how our AI-powered assistants can drive efficiency, growth, and customer satisfaction for your business.</p>
                <Link to="/contact" className="button button--primary">
                    Request a Demo
                </Link>
            </section>
        </div>
    </div>
);


export default Features; 